import api from "./api";
import apiFile from "./apiFile";

export const postMethod = async (link, data) => {
    try {
        const response = await api.post(link, data);
        //console.log(response);
        return response;
    } catch (error) {
        //console.log(error);
        return error;
    }
};

export const getMethod = async (link) => {
    try {
        const response = await api.get(link);
        //console.log(response);
        return response;
    } catch (error) {
        //console.log(error);
        return error;
    }
};

export const postFileMethod = async (link, data) => {
    try {
        const response = await apiFile.post(link, data);
        //console.log(response);
        return response;
    } catch (error) {
        //console.log(error);
        return error;
    }
};
